(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["modal-general"]) return;
  try {
    

// Cookie ophalen
function getCookie(name) {
  const decodedCookie = decodeURIComponent(document.cookie);
  const cookies = decodedCookie.split(';');
  for (let i = 0; i < cookies.length; i++) {
    let c = cookies[i].trim();
    if (c.indexOf(name + "=") === 0) {
      return c.substring((name + "=").length);
    }
  }
  return "";
}

// Cookie instellen
function setCookie(name, value, days) {
  const d = new Date();
  d.setTime(d.getTime() + (days * 24 * 60 * 60 * 1000));
  const expires = "expires=" + d.toUTCString();
  document.cookie = name + "=" + value + ";" + expires + ";path=/";
}

// Wanneer DOM volledig geladen is
document.addEventListener("DOMContentLoaded", function() {
  if (getCookie("ism_POPUP") !== "showed") {
    const modalElement = document.getElementById("ModalGeneral");
    if (modalElement) {
      const myModal = new bootstrap.Modal(modalElement);
      myModal.show();
      setCookie("ism_POPUP", "showed", 1);
    }
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-wishcards"] && !Shopify.designMode) return;
  try {
    
async function loadAllWishcards(filterWishcards) {
  const grid = document.querySelector('#wishcards-grid');

  if (!grid) return;

  const totalPages = Number(grid.dataset.pages);
  const pageParam = grid.dataset.pageParam;
  const totalItems = Number(grid.dataset.totalItems);

  console.log('Wishcards total:', totalItems);
  console.log('Wishcard pages:', totalPages);
  console.log('Page param:', pageParam);

  if (totalPages <= 1) return;

  const requests = [];

  for (let page = 2; page <= totalPages; page++) {
    const url = new URL(window.location.href);

    url.searchParams.set(pageParam, page);

    requests.push(
      fetch(url.toString()).then(async (response) => {
        if (!response.ok) {
          throw new Error(`Could not load page ${page}`);
        }

        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');

        return {
          page,
          cards: [...doc.querySelectorAll('#wishcards-grid .wishcard-item')]
        };
      })
    );
  }

  try {
    const results = await Promise.all(requests);

    results
      .sort((a, b) => a.page - b.page)
      .forEach(({ cards }) => {
        cards.forEach((card) => {
          grid.appendChild(card);
        });
      });

    const cards = [...grid.querySelectorAll('.wishcard-item')];

    cards.sort((a, b) => {
      return a.dataset.title.localeCompare(b.dataset.title, 'nl', {
        sensitivity: 'base'
      });
    });

    cards.forEach((card) => {
      grid.appendChild(card);
    });

    filterWishcards?.();

    console.log(
      'Wishcards loaded:',
      grid.querySelectorAll('.wishcard-item').length
    );
  } catch (error) {
    console.error('Error loading wishcards:', error);
  }
}
function initWishcardFilters() {
  const categoryFilter = document.querySelector('#wishcard-category');
  const typeFilter = document.querySelector('#wishcard-type');
  const searchInput = document.querySelector('#wishcard-search');
  const grid = document.querySelector('#wishcards-grid');

  if (!grid) return;

  function filterWishcards() {
    const selectedCategory = categoryFilter?.value || '';
    const selectedType = typeFilter?.value || '';
    const searchTerm = searchInput?.value.trim().toLowerCase() || '';

    const wishcards = grid.querySelectorAll('.wishcard-item');
    const resultCount = document.querySelector('#wishcards-result-count');
    const resetButton = document.querySelector('#wishcards-reset');
    const emptyState = document.querySelector('#wishcards-empty');

    let visibleCount = 0;

    wishcards.forEach((wishcard) => {
      const matchesCategory =
        !selectedCategory ||
        wishcard.dataset.category === selectedCategory;

      const matchesType =
        !selectedType ||
        wishcard.dataset.type === selectedType;

      const matchesSearch =
        !searchTerm ||
        wishcard.dataset.title.includes(searchTerm) ||
        wishcard.dataset.categoryTitle.includes(searchTerm);

      const matches =
        matchesCategory &&
        matchesType &&
        matchesSearch;

      wishcard.classList.toggle('d-none', !matches);

      if (matches) {
        visibleCount++;
      }
    });

    if (resultCount) {
      resultCount.textContent =
        visibleCount === 1
          ? '1 kaartje gevonden'
          : `${visibleCount} kaartjes gevonden`;
    }

    const hasFilters =
      selectedCategory ||
      selectedType ||
      searchTerm;

    resetButton?.classList.toggle('d-none', !hasFilters);
    emptyState?.classList.toggle('d-none', visibleCount !== 0);
    grid.classList.toggle('d-none', visibleCount === 0);
  }

  function resetFilters() {
    if (categoryFilter) categoryFilter.value = '';
    if (typeFilter) typeFilter.value = '';
    if (searchInput) searchInput.value = '';

    filterWishcards();
  }

  categoryFilter?.addEventListener('change', filterWishcards);
  typeFilter?.addEventListener('change', filterWishcards);
  searchInput?.addEventListener('input', filterWishcards);

  document
    .querySelector('#wishcards-reset')
    ?.addEventListener('click', resetFilters);

  document
    .querySelector('[data-wishcards-reset]')
    ?.addEventListener('click', resetFilters);

  return filterWishcards;
}
const filterWishcards = initWishcardFilters();
loadAllWishcards(filterWishcards);

  } catch(e) { console.error(e); }
})();
})();
